import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { selectPlansListItems } from "../../../../redux/plans/selector";
import { plans } from "../../../../redux/plans/action";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../redux/library/selector";
import Table from "../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";

const ListMarketingPlans = ({
  choosenCampaign,
  handleInnerFormChange,
  customerTags,
  campaignFrequency,
  emailNotes,
  emailBudget,
  choosenEmailPlan,
  selectedTemplate,
  setSelectedTemplate,
  onSelect,
  onPlanIdChange
}: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const result = useSelector(selectCurrent);
  const { header, footer, currency } = result;
  const itemsData = useSelector(selectPlansListItems);
  const libraryData = useSelector(selectListItems);
  const [columnDefs, setColumnDefs] = useState<any>([]);
  const [showTemplate, setShowTemplate] = useState<boolean>(false);
  const [choosenPlan, setChoosenPlan] = useState<any>();
  const [choosenTemplate, setChoosenTemplate] = useState<any>();
  const [selectedPlanId, setSelectedPlanId] = useState<any>();

  // Set initial plan ID based on chosen campaign
  useEffect(() => {
    if (choosenCampaign?.EmailPlanId > 0) {
      setSelectedPlanId(choosenCampaign.EmailPlanId);
    }
  }, [choosenCampaign]);


  useEffect(() => {
    onPlanIdChange(selectedPlanId);
  }, [selectedPlanId, onPlanIdChange]);
  // Update column definitions whenever selectedPlanId changes
  useEffect(() => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer: (params: any) => parseInt(params.node.id, 10) + 1,
      },
     
      { field: 'Name', headerName: 'Plan' },
      {
        field: 'CampaignFrequencyId',
        headerName: 'Frequency',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.CampaignFrequency },
      },
      { field: 'IsEmailCampaignIncluded', headerName: 'Email', cellRenderer: 'yesNoRenderer' },
      { field: 'IsSMSCampaignIncluded', headerName: 'SMS', cellRenderer: 'yesNoRenderer' },
      { field: 'IsWhatsappCampaignIncluded', headerName: 'Whatsapp', cellRenderer: 'yesNoRenderer' },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat: true },
      { field: 'EndDate', headerName: 'End Date', isDateValueFormat: true },
      { field: '', headerName: 'Campaigns', sortable: false, filter: false, cellRenderer: 'customFunctions' },
    ]);
  }, [selectedPlanId, libraryData]);


  const handleSelect = useCallback((planId: any) => {
    setSelectedPlanId(planId[0]?.Id);
  }, []);

  const fetchPlan = () => {
    dispatch(
      plans.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/list`,
        entity: 'plans',
        jsonData: {
          PageNumber: pageData,
          PageSize: pageSize,
        },
      })
    );
  };

  useEffect(() => {
    fetchPlan();
  }, [pageData, pageSize]);

  return (
    <>
      {itemsData?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          headingName="Plans"
          onSelect={handleSelect}
          checkboxConfig={{
            allowMultiSelect: false,
            defaultSelectedIds: selectedPlanId,
            isDisabled: false,
            keyColumn: 'Id',
          }}
        />
      )}
    </>
  );
};

export default ListMarketingPlans;
